<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e283"><i>The </i>MIRACLE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morr_9780310252344_epub_c4_r1.vue?0df9417c